import { render, staticRenderFns } from "./Keywordroleprivileges.vue?vue&type=template&id=a5af778e&scoped=true"
import script from "./Keywordroleprivileges.vue?vue&type=script&lang=js"
export * from "./Keywordroleprivileges.vue?vue&type=script&lang=js"
import style0 from "./Keywordroleprivileges.vue?vue&type=style&index=0&id=a5af778e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5af778e",
  null
  
)

export default component.exports